import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Embed } from 'embed';
import * as pbi from 'powerbi-client';
import { ICustomEvent } from 'service';

import { createConfig } from '@views/pages/export-report/create-config';
import { PowerbiTokenService } from './powerbi-token.service';

const isUnauthorizedError = (code) => Number(code) === 403;

@Injectable()
export class PowerbiEmbedService {
  private powerbi = new pbi.service.Service(
    pbi.factories.hpmFactory,
    pbi.factories.wpmpFactory,
    pbi.factories.routerFactory,
  );

  constructor(private http: HttpClient, private powerbiTokenService: PowerbiTokenService) {}

  async generateReport(element, reportId): Promise<Observable<Embed>> {
    const microsoftToken = this.powerbiTokenService.microsoftToken;
    if (microsoftToken) this.embedReport({ element, reportId, token: microsoftToken });

    const token = await this.powerbiTokenService.requestToGetToken();
    return this.embedReport({ element, reportId, token });
  }

  private async unauthorizedHandler(element, reportId) {
    this.powerbiReset(element);
    const token = await this.powerbiTokenService.requestToGetToken();
    return this.powerBiEmbed({ element, reportId, token });
  }

  private embedReport({ element, reportId, token }): Observable<Embed> {
    return new Observable((subscriber) => {
      const powerbiEmbed = this.powerBiEmbed({ element, reportId, token });
      subscriber.next(powerbiEmbed);

      const handleError = async ({ detail }: ICustomEvent<any>) => {
        if (isUnauthorizedError(detail.errorCode)) {
          const result = await this.unauthorizedHandler(element, reportId);
          subscriber.next(result);
          return;
        }

        subscriber.next(null);
      };

      powerbiEmbed.on('error', handleError);
    });
  }

  private powerBiEmbed = ({ element, reportId, token }) => this.powerbi.embed(element, createConfig(token, reportId));
  private powerbiReset = (element) => this.powerbi.reset(element);
}
